import {
  Avatar,
  Badge,
  Box,
  Button,
  Flex,
  Image,
  Link,
  List,
  Menu,
  MenuButton,
  MenuDivider,
  MenuList,
  Text,
  useBreakpointValue,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";
import AdminQuickActions from "./AdminQuickActions";
import Notifications from "./Notifications";
import { useResponsive } from "../../Contexts/ResponsiveContext";

function Header() {
  const {
    isAdmin,
    handleLogout,
    currentUser,
    currentUserDetails,
    isAuthenticated,
  } = useAuth();
  const { isMobile } = useResponsive();

  console.log("currentUserDetails", currentUserDetails);

  return (
    <Flex
      as="header"
      align="center"
      justifyContent="space-between"
      padding="4"
      // bg={"white"}
      bgGradient="linear(to-r, #1b193e, blue.600)"
      color="white"
    >
      <Link as={RouterLink} to="/">
        <Image
          src="/images/inovora-logo-white.png"
          alt="My Logo"
          height={isMobile ? "30px" : "40px"}
          position="relative"
          top="-4px"
        />
      </Link>

      {!isMobile && isAdmin && <AdminQuickActions />}
      <Notifications />

      {/* User Avatar and Menu */}
      {isAuthenticated ? (
        <Flex alignItems={"center"}>
          {currentUser && (
            <Text
              fontSize={isMobile ? "xs" : "sm"}
              color="white"
              textAlign={"end"}
              mr={0}
            >
              {currentUser.email}
            </Text>
          )}
          <Menu>
            <MenuButton
              px={0}
              mr={2}
              as={Button}
              variant="ghost"
              rightIcon={
                <Avatar
                  size="sm"
                  name={currentUser?.displayName}
                  bg={"#993695"}
                  color={"white"}
                />
              }
              _hover={{ bg: "transparent" }}
              _active={{ bg: "transparent" }}
            />
            <MenuList zIndex="10">
              <Box px={4} py={2} display="flex" alignItems="center" mb={4}>
                <Avatar
                  size="md"
                  name={currentUser?.displayName}
                  mr={3}
                  bg={"#993695"}
                  color={"white"}
                />
                <VStack align="left" spacing={0} color={"black"}>
                  <Flex gap={1}>
                    {/* <Badge
                      variant="outline"
                      lineHeight={2}
                      fontSize={"2xs"}
                      borderRadius={"sm"}
                      colorScheme="teal"
                    >
                      {currentUserDetails?.client || "No Access"}
                    </Badge> */}
                  </Flex>
                  <Text fontWeight="bold">
                    {currentUserDetails?.name ||
                      currentUser?.displayName ||
                      "Unknown User"}
                  </Text>
                  <Text color={"gray.500"} fontSize="xs">
                    {currentUser?.email || "-"}
                  </Text>
                </VStack>
              </Box>
              <MenuDivider />
              <List spacing={2} fontSize={"sm"} mx={5} maxW={"300px"}>
                {/* Additional user details or links */}
              </List>
              <MenuDivider />
              <Flex justifyContent={"end"} w={"100%"}>
                <Button
                  size={"sm"}
                  mr={4}
                  my={1}
                  colorScheme="blue"
                  color={"white"}
                  onClick={handleLogout}
                >
                  Sign Out
                </Button>
              </Flex>
            </MenuList>
          </Menu>
        </Flex>
      ) : (
        <RouterLink to="/signin">
          <Link color={"white"}>Sign In</Link>
        </RouterLink>
      )}
    </Flex>
  );
}

export default Header;
